import grapesjsTouch from 'grapesjs-touch';
import PMWEmailEditorPlugin from '../src/index.ts';
import PMWEmailsNamespace from "../src/var.ts";

PMWEmailsNamespace();

const GRAPESJS_CONFIG = {
    mode: 'simple',
    avoidInlineStyle: false,
    forceClass: false,
    container: '#html-editor-canvas',
    height: '100%',
    multipleSelection: true,
    cssIcons: null,
    noticeOnUnload: 1,
    canvas: {
        frameContent: '',
        styles: [PMW.util.asset_url(`css/email-maker/editor-canvas.css?v=${PMW.VERSION}`)],
        customBadgeLabel: component => {
            let name = component.get('name');

            return `<span class="toolbar-name"> ${typeof name === 'function' ? name() : name}</span>`;
        },
    },
    styleManager: {
        appendTo: '.html-editor-style-manager',
        sectors: []
    },
    keymaps: {
        defaults: {},
    },
    richTextEditor: {
        stylePrefix: 'rte-',
        adjustToolbar: 1,
        actions: ['bold', 'underline', 'italic', 'strikethrough', 'link'],
    },
    assetManager: {
        upload: PMW.util.site_url('posterimage/emailUpload'),
        uploadName: 'files',
        autoAdd: 1
    },
    storageManager: {
        type: 'remote-storage',
        autosave: false,
        stepsBeforeSave: 1,
        onStore: (data, editor) => editor.StorageManager.getCurrentStorage().onStore(data, editor),
        onLoad: (data, editor) => editor.StorageManager.getCurrentStorage().onLoad(data, editor),
    },
    panels: {
        defaults: []
    },
    selectorManager: {
        componentFirst: true,
    },
    deviceManager: {
        default: window.PMW.emails.DEVICE_DESKTOP,

        devices: [
            {
                id: window.PMW.emails.DEVICE_DESKTOP,
                name: 'Desktop',
                width: '100%',
                minWidthMedia: '767px',
            },
            {
                id: window.PMW.emails.DEVICE_TABLET,
                name: 'Tablet',
                width: '600px',
                widthMedia: '768px',
                minWidthMedia: '501px',
            },
            {
                id: window.PMW.emails.DEVICE_MOBILE,
                name: 'Mobile',
                width: '345px',
                widthMedia: '500px',
            },
        ],
    },
    undoManager: {
        trackSelection: 0,
    },
    plugins: [PMWEmailEditorPlugin, grapesjsTouch],
    parser: {
        optionsHtml:{
            allowScripts: false,
            allowUnsafeAttr: false,
        }
    }
};

export {GRAPESJS_CONFIG as default};
